// extracted by mini-css-extract-plugin
module.exports = {"container":"LMrCLIHU","logout":"_3FK9FObo","logoutText":"_1Vh49Y5C","menuItem":"_3Td_pg59","email":"_3GjrSxe5","list":"_2l1L3s_H","footer":"OH35BrTg"};